module.exports = __webpack_public_path__ + "static/media/InstructionsSoundClowd.bc758c65.jpg";